// import Package from "@components/icons/Package"
import { useSliceContext } from "@components/SliceProvider"
// import { ProductCart } from "@src/lib/cart/handleUpdateCart"
import { Button } from "@components/ui/base/button"
// import { getSliceSubdomain } from "@src/lib/getSliceSubdomain"

export const CONFIRM_PURCHASE_VIEW = (params: any) => {
  const { setModalView } = useSliceContext()
  // const { cartItems } = params as { cartItems: ProductCart[] }

  // const redeemableProducts = cartItems
  //   .filter((el) => el.redeemButton)
  //   .map(({ slicerId, productId }) => `slicer=${slicerId}&product=${productId}`)
  //   .join("&")

  return (
    <div className="sl-text-center">
      <div className="sl-pb-12">
        <h1 className="sl-fonts">Purchase summary</h1>
      </div>
      {/* <PurchasesConfirmationList cart={cartItems} /> */}
      {/* {redeemableProducts.length != 0 ? (
        <div className="sl-space-y-8">
          <Button
            label={
              <span className="sl-flex sl-items-center sl-gap-2">
                <span>Redeem all</span>
                <Package className="sl-w-5 sl-h-5" />
              </span>
            }
            href={`https://${getSliceSubdomain()}redeem.slice.so?${redeemableProducts}`}
          />
          <p className="sl-text-sm sl-text-gray-500">
            Some products require an additional step to be redeemed
          </p>
        </div>
      ) : ( */}
      <Button onClick={() => setModalView({ name: "" })}>Close</Button>
      {/* )} */}
    </div>
  )
}

export default CONFIRM_PURCHASE_VIEW

// TODO: New redeem flow
